(function (ws) {
    'use strict';
    ws.views.avayaQuoteDetailTable = ws.views.staticTable.extend({

        /**
         * Events override
         */
        events: _.extend({}, ws.views.simpleTable.prototype.events, {
            'click .export-quote-detail': 'downloadMultipleOrder'
        }),

        /**
         * Initialize override
         */
        initialize: function() {
            this.$table = this.$('#avaya-quotedetail-table');
            if ($('#ckpflag').val() === 'true') {
                ws.views.staticTable.prototype.initialize.call(this);
                $('table tr:last-child td:first-child').attr('class', '');
            } else {
                this.$table.dataTable({
                    searching: false,
                    paging: false,
                    info: false,
                    sorting: false
                });
            }
        },

        /**
         * Downloading orders excel functionality
         */
        downloadMultipleOrder: function (e) {
            globals.disableApp();
            let downloadText = $('.downloadAfterText').html();
            let quoteId = this.$(e.currentTarget).data('quoteId');
            let versionId = this.$(e.currentTarget).data('versionId');
            const CSRFToken = CSRF;
            const urlExportOrderList = globals.path.api.westcon.exportSelectedOrder + `/${quoteId}/${versionId}?` + CSRFToken;

            // DOWNLOADING EXCEL FILE FROM THE BLOB.
            const xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                var a;
                if (xhttp.readyState === 4 && xhttp.status === 200) {
                    // Trick for making downloadable link
                    if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
                        navigator.msSaveBlob(xhttp.response, `${downloadText}-${quoteId}.xls`);
                    } else {
                        a = document.createElement('a');
                        a.href = window.URL.createObjectURL(xhttp.response);

                        // Give filename you wish to download
                        a.download = `${downloadText}-${quoteId}.xls`;
                        a.style.display = 'none';
                        document.body.appendChild(a);
                        a.click();
                    }

                    globals.enableApp();
                }
            };

            xhttp.open('POST', urlExportOrderList);
            xhttp.setRequestHeader('Content-Type', 'application/json');
            xhttp.responseType = 'blob';
            xhttp.send();
        }

    });
})(westcon);
